import React, { createContext, useMemo } from 'react'
import { Box, Typography, Grid, Skeleton, Button, Hidden } from '@mui/material'
import { PageContainer } from '../component/styled/PageContainer'
import { Helmet } from 'react-helmet-async'
import { Navbar } from '../component/shared/Navbar'
import { StaffBenefitCard } from '../component/staff-benefit-claim/StaffBenefitCard'
import ErrorMessage from '../component/shared/component/ErrorMessage'
import { useGetStaffBenefits } from '../api/staff-benefit'
import { useAuth } from '../api/context/UserAuthContext'

const initState = {
  refetch: undefined,
}
export const StaffBenefitClaimContext = createContext(initState)

export const StaffBenefitUserPanelScreen = () => {
  const { user } = useAuth()

  const { data, isLoading, error, refetch } = useGetStaffBenefits({ activeOnly: true })

  const staffData = data?.docs ?? []

  const staffBenefitArray = useMemo(() => {
    let tmpArray = []
    staffData.map((staffBenefit) => {
      //check if the user is eligible for the benefit
      const hasUsers = staffBenefit?.users.length > 0
      const isEligible = staffBenefit?.users.some((curUser) => user.id === curUser?.user.id)
      const userCheck = !hasUsers || (hasUsers && isEligible)

      //check if department eligible
      const isRedemptionLimitByDepartment = staffBenefit.departments?.length > 0
      const departmentEligible = staffBenefit?.departments.some(
        (x) => x.department === user.department
      )
      const departmentCheck =
        !isRedemptionLimitByDepartment || (isRedemptionLimitByDepartment && departmentEligible)

      if (userCheck && departmentCheck) {
        return tmpArray.push(staffBenefit)
      }
    })
    return tmpArray
  }, [staffData])

  return (
    <StaffBenefitClaimContext.Provider value={{ refetch }}>
      <PageContainer>
        <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
          <title>Staff Benefits</title>
        </Helmet>
        <Navbar />
        <Box p={{ xs: 3, md: 5 }}>
          <Box mb={2} display='flex' justifyContent='space-between'>
            <Typography variant='h1'>Staff Benefits</Typography>
            <Hidden mdDown>
              <Button
                component='a'
                href='/staff-benefit-claims'
                variant='contained'
                color='primary'
              >
                View Staff Benefit Claims
              </Button>
            </Hidden>
          </Box>
          <Hidden mdUp>
            <Box mb={2}>
              <Button
                component='a'
                href='/staff-benefit-claims'
                variant='contained'
                color='primary'
              >
                View Staff Benefit Claims
              </Button>
            </Box>
          </Hidden>
          <Grid container spacing={2}>
            {isLoading ? (
              <>
                {Array(6)
                  .fill()
                  .map((_, idx) => (
                    <Grid item xs={12} md={6} lg={4} key={idx}>
                      <Skeleton key={idx} height='210px' />
                    </Grid>
                  ))}
              </>
            ) : error ? (
              <ErrorMessage error={error} />
            ) : staffBenefitArray.length > 0 ? (
              <>
                {staffBenefitArray?.map((staffBenefit, idx) => {
                  return (
                    <Grid item xs={12} md={6} lg={4} key={idx}>
                      <StaffBenefitCard staffBenefit={staffBenefit} />
                    </Grid>
                  )
                })}
              </>
            ) : (
              <ErrorMessage empty />
            )}
          </Grid>
        </Box>
      </PageContainer>
    </StaffBenefitClaimContext.Provider>
  )
}
